import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.24902 13.9914V16.2714C2.24902 16.4814 2.41402 16.6464 2.62402 16.6464H4.90402C5.00152 16.6464 5.09902 16.6089 5.16652 16.5339L13.3565 8.35141L10.544 5.53891L2.36152 13.7214C2.28652 13.7964 2.24902 13.8864 2.24902 13.9914Z",
		fill: "#3C59F6"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.5315 5.11891L13.7765 3.36391C13.484 3.07141 13.0115 3.07141 12.719 3.36391L11.3465 4.73641L14.159 7.54891L15.5315 6.17641C15.824 5.88391 15.824 5.41141 15.5315 5.11891Z",
		fill: "#3C59F6"
	})]
});
export default SvgEdit;
